import DiscreteSlider from './DiscreteSlider';

export default DiscreteSlider;
